const About = (): React.JSX.Element => {
   return (
      <article className="md-content__inner md-typeset">
         <h1 id="installation">About Us</h1>
         <p>
            Developed at{' '}
            <a href="https://bioinformatika.mff.cuni.cz/cusbg/">Charles University Structural Bioinformatics Group</a>.
         </p>
         <p>
            Check out our other bioinformatics tools:&nbsp;
            <a href="https://github.com/rdk/p2rank">P2Rank</a>, <a href="https://prankweb.cz/">PrankWeb</a>,&nbsp;
            <a href="https://github.com/cusbg/traveler">Traveler</a>, and&nbsp;
            <a href="https://bioinformatika.mff.cuni.cz/cusbg/index.html#software">others</a>.
         </p>
         <h2>Authors</h2>
         <a href="https://github.com/ioChris">Christos Feidakis</a> (christos.feidakis [at] natur.cuni.cz)
         <br />
         <a href="https://github.com/rdk">Radoslav Krivak</a> (rkrivak [at] gmail.com)
         <br />
         David Hoksza
         <br />
         Marian Novotný
         <h2>Publications</h2>
         If you find AHoJ or AHoJ-DB useful, please cite our work.
         <p>
            AHoJ:&nbsp;{' '}
            <a
               href="https://doi.org/10.1093/bioinformatics/btac701"
               style={{ fontWeight: 'bold', color: '#800080', textDecoration: 'underline' }}
            >
               Article
            </a>
            &nbsp;{' '}
            <a
               href="https://pubmed.ncbi.nlm.nih.gov/36282546/"
               style={{ fontWeight: 'bold', color: '#800080', textDecoration: 'underline' }}
            >
               PubMed
            </a>
         </p>
         <p>
            AHoJ-DB:&nbsp;{' '}
            <a
               href="https://doi.org/10.1016/j.jmb.2024.168545"
               style={{ fontWeight: 'bold', color: '#800080', textDecoration: 'underline' }}
            >
               Article
            </a>
            &nbsp;{' '}
            <a
               href="https://pubmed.ncbi.nlm.nih.gov/38508305/"
               style={{ fontWeight: 'bold', color: '#800080', textDecoration: 'underline' }}
            >
               PubMed
            </a>
         </p>
         <h2>Feedback</h2>
         We would be happy to hear about your use cases, experiences and ideas/feature requests.
         <br />
         Either raise an issue in <a href="https://github.com/cusbg/AHoJ-project/issues">GitHub issues tracker</a>
         or get in touch by mail.
         <br />
         Please address any correspondence to both (christos.feidakis [at] natur.cuni.cz) and (rkrivak [at] gmail.com).
         <br />
         <br />
         <br />
      </article>
   );
};

export default About;
